export default "__VITE_ASSET__81ad4c40__"